import { useMutation, useQuery, useQueryClient } from "@tanstack/vue-query";
import { apiCall } from "@/core/utils/api";
import { meetingModulesList, meetingsModulesToggleCreate } from "@sgdf/client";

export const useModules = () => {
  return useQuery({
    queryKey: ["modules"],
    queryFn: () => apiCall(meetingModulesList()),
  });
};

export const useModuleToggle = () => {
  const meetingId = useMeetingId();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (options: { id: string }) =>
      apiCall(meetingsModulesToggleCreate({
        path: { meeting_id: meetingId.value!, module_id: options.id },
      })),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ["meetings"],
      });
      queryClient.invalidateQueries({
        queryKey: ["public-meetings", meetingId.value],
      });
    },
  });
};

export const useModule = () => {
  const store = useUserStore();
  const { hasModule } = storeToRefs(store);

  return hasModule;
};
